// extracted by mini-css-extract-plugin
export default {"page":"zY-z","cartModal":"AY-z","checkout":"BY-z","placeholder":"CY-z","account":"DY-z"};